<script lang="ts" setup>
    import { reactive, watch } from 'vue';
    import { IPatientEnhancedAccessItem } from '../../lib/Models/PatientModel';
    import * as ChoiceApi from '../../lib/ChoiceApi';

    const emit = defineEmits<{
        (e: "onLoad", accessDataExists: boolean): void
    }>();

    const props = defineProps<{
        patientEntityId?: number,
    }>(
    );

    const formData = reactive<{
        accessList: IPatientEnhancedAccessItem[]
    }>({
        accessList: []
    });

    watch(() => props.patientEntityId, (_newVal, _oldVal) =>{
        loadData();
    });

    async function loadData() {
        formData.accessList = [];
        if (props.patientEntityId) {
            const result = await ChoiceApi.patient.getPatientEnhancedAccessList(props.patientEntityId);
            if (result)
                formData.accessList = result;
        }
        emit("onLoad", formData.accessList.length > 0);
    }
</script>

<template>
    <template v-if="formData.accessList.length === 0">
        No Enhanced Access Information Exists
    </template>
    <template v-else>
        <table style="width: 100%; table-layout: fixed">
            <colgroup><col><col width=70><col width=20></colgroup>
            <tr v-for="item in formData.accessList">
                <td title="User who accessed the chart.">{{ item.usersId }}</td>
                <td title="When the chart was accessed by the user.">{{ item.accessDate }}</td>
                <td style="text-align: right" title="Number of times chart was accessed by user on the given date.">{{ item.accessCount }}</td>
            </tr>
        </table>
    </template>
</template>

